export const distributionChannelLabels = {
  official: '官网',
  huawei: '华为应用市场',
  xiaomi: '小米应用商店',
  oppo: 'OPPO 软件商店',
  vivo: 'vivo 应用商店',
  honor: '荣耀应用市场',
  tencent: '应用宝',
  legacy: '历史用户',
  unknown: '未知渠道',
};

export const distributionChannelOptions = Object.entries(distributionChannelLabels).map(
  ([value, label]) => ({ value, label })
);

export const channelLabel = (channel) => distributionChannelLabels[channel] || channel || '未知渠道';
